import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { readSchemaSlotFields } from './read-schema-slot-fields.js'

export function getTabFields(tab: NonNullable<SchemaField['tabs']>[number]): SchemaField[] {
  return tab.slot ? readSchemaSlotFields(tab.slot) : (tab.fields ?? [])
}
